const CONSENT_KEY = "olivex-shopify-consent-preview";
let customerPrivacyApi = null;

function selectedOption(select) {
  return select.options[select.selectedIndex];
}

function syncVariantSelect(select) {
  const option = selectedOption(select);
  const form = select.closest("[data-product-form], [data-sticky-product-form]");
  const hiddenInput = form?.querySelector('input[name="id"][type="hidden"]');
  const shell = form?.closest("[data-product-shell]");
  const price = option?.dataset.price;

  if (hiddenInput) hiddenInput.value = select.value;
  if (!price) return;

  shell?.querySelectorAll("[data-current-price]").forEach((target) => {
    target.textContent = price;
  });

  form?.querySelectorAll("[data-sticky-price]").forEach((target) => {
    target.textContent = price;
  });
}

function readConsent() {
  try {
    const saved = localStorage.getItem(CONSENT_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
}

function applyConsent(consent, { showBanner = !consent } = {}) {
  const saved = Boolean(consent);
  const banner = document.querySelector("[data-consent-banner]");

  document.documentElement.dataset.analyticsConsent = consent?.analytics ? "granted" : "denied";
  document.documentElement.dataset.marketingConsent = consent?.marketing ? "granted" : "denied";
  document.body.classList.toggle("consent-open", Boolean(showBanner));

  if (banner) banner.hidden = !showBanner;
  document.querySelectorAll("[data-consent-reopen]").forEach((button) => {
    button.hidden = false;
  });
}

function saveLocalConsent(consent) {
  const payload = {
    necessary: true,
    analytics: Boolean(consent.analytics),
    marketing: Boolean(consent.marketing),
    preferences: Boolean(consent.preferences),
    savedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(payload));
  } catch {
    // Storage can be unavailable in strict browser modes; the visible state still updates.
  }

  return payload;
}

function setConsentStatus(message = "") {
  const status = document.querySelector("[data-consent-status]");
  if (!status) return;
  status.textContent = message;
  status.hidden = !message;
}

function setConsent(consent) {
  const payload = {
    analytics: Boolean(consent.analytics),
    marketing: Boolean(consent.marketing),
    preferences: Boolean(consent.preferences),
  };

  const finish = (result = {}) => {
    if (result?.error) {
      setConsentStatus("Valget kunne ikke lagres hos Shopify. Prøv igjen, eller bruk butikkens personvernvalg senere.");
      applyConsent(null, { showBanner: true });
      return;
    }

    setConsentStatus();
    hideConsentPreferences();
    applyConsent(saveLocalConsent(payload), { showBanner: false });
  };

  if (customerPrivacyApi?.setTrackingConsent) {
    try {
      customerPrivacyApi.setTrackingConsent(payload, finish);
    } catch (_error) {
      finish({ error: ["tracking-consent-request-failed"] });
    }
  } else {
    finish();
  }
}

function consentFromShopify(api) {
  const current = api?.currentVisitorConsent?.() || {};
  const hasDecision = [current.analytics, current.marketing, current.preferences].some((value) => value === "yes" || value === "no");
  return {
    hasDecision,
    consent: {
      analytics: current.analytics === "yes",
      marketing: current.marketing === "yes",
      preferences: current.preferences === "yes",
    },
  };
}

function loadCustomerPrivacyApi() {
  return new Promise((resolve) => {
    if (!window.Shopify?.loadFeatures) {
      resolve(null);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      (error) => resolve(error ? null : window.Shopify.customerPrivacy || null),
    );
  });
}

function syncConsentInputs(consent = {}) {
  document.querySelectorAll("[data-consent-toggle]").forEach((input) => {
    input.checked = Boolean(consent[input.dataset.consentToggle]);
  });
}

function hideConsentPreferences() {
  const preferences = document.querySelector("[data-consent-preferences]");
  const settings = document.querySelector("[data-consent-settings]");
  const save = document.querySelector("[data-consent-save]");

  if (!preferences || !settings || !save) return;
  preferences.hidden = true;
  settings.setAttribute("aria-expanded", "false");
  save.hidden = true;
}

function showConsentBanner(shouldFocus = false) {
  const banner = document.querySelector("[data-consent-banner]");
  if (!banner) return;

  const current = customerPrivacyApi ? consentFromShopify(customerPrivacyApi).consent : readConsent() || {};
  setConsentStatus();
  syncConsentInputs(current);
  applyConsent(null, { showBanner: true });
  if (shouldFocus) document.querySelector("[data-consent-settings]")?.focus();
}

function toggleConsentPreferences() {
  const preferences = document.querySelector("[data-consent-preferences]");
  const settings = document.querySelector("[data-consent-settings]");
  const save = document.querySelector("[data-consent-save]");

  if (!preferences || !settings || !save) return;
  const nextOpen = preferences.hidden;
  preferences.hidden = !nextOpen;
  settings.setAttribute("aria-expanded", nextOpen ? "true" : "false");
  save.hidden = !nextOpen;
}

function saveCustomConsent() {
  const consent = {};
  document.querySelectorAll("[data-consent-toggle]").forEach((input) => {
    consent[input.dataset.consentToggle] = input.checked;
  });
  setConsent(consent);
}

function closeMobileMenuAfterNavigation(event) {
  const link = event.target.closest(".ox-mobile-menu a");
  if (!link) return;
  link.closest("details")?.removeAttribute("open");
}

function initMobileStickyBuy() {
  const sticky = document.querySelector("[data-mobile-sticky-buy]");
  const purchase = document.getElementById("bestill");
  if (!sticky || !purchase || !("IntersectionObserver" in window)) return;

  const blockers = [purchase, ...document.querySelectorAll("[data-mobile-sticky-blocker]")];
  const visibleBlockers = new Set();

  const setHidden = (hidden) => {
    if (hidden && sticky.contains(document.activeElement)) {
      purchase.querySelector('input:not([disabled]), button:not([disabled]), a[href]')?.focus({ preventScroll: true });
    }
    sticky.classList.toggle("is-hidden", hidden);
    sticky.toggleAttribute("inert", hidden);
    sticky.setAttribute("aria-hidden", hidden ? "true" : "false");
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibleBlockers.add(entry.target);
        else visibleBlockers.delete(entry.target);
      });
      setHidden(visibleBlockers.size > 0);
    },
    { rootMargin: "-15% 0px -15% 0px", threshold: 0 },
  );
  blockers.forEach((blocker) => observer.observe(blocker));
}

document.addEventListener("change", (event) => {
  const select = event.target.closest("[data-variant-select]");
  if (select) syncVariantSelect(select);
});

document.addEventListener("click", (event) => {
  closeMobileMenuAfterNavigation(event);

  if (event.target.closest("[data-consent-settings]")) {
    toggleConsentPreferences();
  }

  if (event.target.closest("[data-consent-reject]")) {
    setConsent({ analytics: false, marketing: false, preferences: false });
  }

  if (event.target.closest("[data-consent-accept]")) {
    setConsent({ analytics: true, marketing: true, preferences: true });
  }

  if (event.target.closest("[data-consent-save]")) {
    saveCustomConsent();
  }

  if (event.target.closest("[data-consent-reopen]")) {
    showConsentBanner(true);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  loadCustomerPrivacyApi().then((api) => {
    customerPrivacyApi = api;
    if (!api) {
      applyConsent(readConsent());
      return;
    }

    const current = consentFromShopify(api);
    const showBanner = Boolean(api.shouldShowBanner?.()) && !current.hasDecision;
    syncConsentInputs(current.consent);
    applyConsent(current.hasDecision ? current.consent : null, { showBanner });
    if (showBanner) window.requestAnimationFrame(() => document.querySelector("[data-consent-settings]")?.focus());
  });
  initMobileStickyBuy();
});
